/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "place.stream.media.createUpload";

export { $nsid };

export const $params = /*#__PURE__*/ l.params();

export type $Params = l.InferOutput<typeof $params>;

export const $input = /*#__PURE__*/ l.jsonPayload({"size":/*#__PURE__*/ l.integer(),"mimeType":/*#__PURE__*/ l.string(),"filename":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),"draftUri":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string())});

export type $Input<B = l.BinaryData> = l.InferPayload<typeof $input, B>;
export type $InputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $input, B>;

export const $output = /*#__PURE__*/ l.jsonPayload({"uploadId":/*#__PURE__*/ l.string(),"uploadUrl":/*#__PURE__*/ l.string({"format":"uri"}),"uploadToken":/*#__PURE__*/ l.string(),"expiresAt":/*#__PURE__*/ l.string({"format":"datetime"})});

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>;
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<typeof $output, B>;

/** Start a resumable upload of arbitrary media content. Returns a TUS upload URL and a short-lived bearer token used to authenticate subsequent chunk requests (no DPoP required on chunks). The DID of the authenticated user is recorded against the upload; on completion a VOD processing task is enqueued. */
const main = /*#__PURE__*/ l.procedure($nsid, $params, $input, $output, ["UploadTooLarge","UnsupportedMimeType"]);

export { main };

export const $lxm = $nsid;
